export function extractYouTubeVideoId(
  url: string,
  options: { fuzzy: boolean } = { fuzzy: true }
): string | null {
  if (!url) return null;

  // Check if the URL contains a YouTube domain
  if (!/youtu\.?be/.test(url)) return null;

  const patterns: RegExp[] = [
    /youtu\.be\/([^#&?]{11})/, // youtu.be/<id>
    /youtube\.com\/shorts\/([^#&?]{11})/, // youtube.com/shorts/<id>
    /\?v=([^#&?]{11})/, // ?v=<id>
    /&v=([^#&?]{11})/, // &v=<id>
    /embed\/([^#&?]{11})/, // embed/<id>
    /\/v\/([^#&?]{11})/, // /v/<id>
    /\/vi\/([^#&?]{11})/, // /vi/<id>
    /\/watch\?.*v=([^#&?]{11})/ // /watch?*v=<id>
  ];

  // Try each pattern in sequence
  for (let i = 0; i < patterns.length; i++) {
    const match = patterns[i].exec(url);
    if (match) {
      return match[1];
    }
  }

  // Fallback to fuzzy matching if enabled
  if (options.fuzzy) {
    // Split the URL by common separators and look for an 11-character string
    // that could be a YouTube ID (alphanumeric plus - and _)
    const tokens = url.split(/[/&?=#.\s]/g);

    for (let i = 0; i < tokens.length; i++) {
      // YouTube IDs are exactly 11 characters and only contain certain characters
      if (/^[a-zA-Z0-9_-]{11}$/.test(tokens[i])) {
        return tokens[i];
      }
    }
  }

  return null;
}

export function createYouTubeEmbedUrl(
  url: string,
  options: { fuzzy: boolean } = { fuzzy: true }
): string | null {
  const videoId = extractYouTubeVideoId(url, options);

  if (!videoId) {
    return null;
  }

  // Create proper embed URL
  return `https://www.youtube.com/embed/${videoId}`;
}
